import { UseMutationOptions } from '@tanstack/react-query';

import { GenericFailure } from '@playq/services-shared';
import { Environment } from '@playq/octopus-common';

import { useEitherMutation } from '/api/service-hooks';

import { IBeetleId } from './types';
import { methods } from './serviceHandlerRequest';
import { audienceQueryKeys } from './constants';
import { SupportContentType } from './types/supportContentType';

export const useAddNote = (
  type: SupportContentType,
  options?: UseMutationOptions<string, GenericFailure | Error, { id: IBeetleId; note: string; env: Environment }>
) => {
  const service = methods(type);
  return useEitherMutation(({ id, note, env }) => service.addNote(id, note, env), {
    removeQueriesKeys: audienceQueryKeys,
    ...options,
  });
};
